import React, { useState, useEffect, useCallback, FunctionComponent } from "react";
import { Card, DatePicker, Button, Space, Spin, Tag } from "antd";
import PropTypes from "prop-types";
import moment, { Moment } from "moment";
import { connect } from "react-redux";
import { FulfillmentCompletionsByUserRecord } from "../../../redux/types/reportTypes";
import { StoreType } from "../../../redux/store";
import fetchFulfillmentCompletionsByUser, {
  FetchFulfillmentCompletionsByUser,
} from "../../../redux/actions/reports/fetchFulfillmentCompletionsByUser";
import UserTable from "./UserTable";
import UserCSV from "./UserCSV";

type FulfillmentTeamItemsProps = {
  fetchUsers: FetchFulfillmentCompletionsByUser;
  userLoading: boolean;
  userRecords: Array<FulfillmentCompletionsByUserRecord>;
};

const initialFilters = () => {
  const endDate = moment();
  const startDate = moment().add(-1, "month");
  return { startDate, endDate };
};

export const FulfillmentTeamItems: FunctionComponent<FulfillmentTeamItemsProps> = ({
  fetchUsers,
  userLoading,
  userRecords,
}: FulfillmentTeamItemsProps) => {
  const [startDate, setStartDate] = useState<Moment>(moment());
  const [endDate, setEndDate] = useState<Moment>(moment());

  const setInitialState = useCallback(() => {
    const initial = initialFilters();
    fetchUsers(initial);
    setStartDate(initial.startDate);
    setEndDate(initial.endDate);
  }, [fetchUsers]);

  useEffect(() => {
    setInitialState();
  }, [setInitialState]);

  const onCalendarChange = (dates: any) => {
    const [startDate, endDate] = dates as [Moment, Moment];
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const onClick = () => {
    fetchUsers(filters());
  };

  const filters = () => ({ startDate, endDate });

  const userExtra = () => {
    if (userLoading) return <Spin />;
    return <Tag color="geekblue">{`${userRecords.length} Result(s)`}</Tag>;
  };

  const extra = () => (
    <Space direction="horizontal">
      <DatePicker.RangePicker
        allowClear={false}
        onCalendarChange={onCalendarChange}
        value={[startDate, endDate]}
      />
      <Button type="primary" onClick={onClick}>
        Filter
      </Button>
      <Button onClick={setInitialState}>Clear</Button>
      <UserCSV data={userRecords} />
      {userExtra()}
    </Space>
  );

  return (
    <Card title="Fulfillment Completions by User" extra={extra()}>
      <UserTable loading={userLoading} records={userRecords} />
    </Card>
  );
};

const mapDispatchToProps = {
  fetchUsers: fetchFulfillmentCompletionsByUser,
};

const mapStateToProps = ({
  reports: {
    fulfillment_completions_by_user: { loading: userLoading, records: userRecords },
  },
}: StoreType) => ({ userLoading, userRecords });

FulfillmentTeamItems.propTypes = {
  fetchUsers: PropTypes.func.isRequired,
  userLoading: PropTypes.bool.isRequired,
  userRecords: PropTypes.array.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(FulfillmentTeamItems);
